import { useQuery } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';
import type { ResourceApproval } from '@/data/subsidy/interfaces';

type AvailableForRefundResponse = {
  resource_approvals: ResourceApproval[];
};

export const useAvailableForRefundRequest = (enabled?: boolean) => {
  const response = useQuery<AvailableForRefundResponse>({
    queryKey: [clientKeys.useAvailableForRefundRequest],
    queryFn: async () => {
      return falconClient.get(
        `${baseUrl}/resource_approvals/available_for_refund_request`
      );
    },
    enabled,
  });

  return {
    resourceApprovals: response?.data?.resource_approvals || [],
    ...response,
  };
};
